import { render, staticRenderFns } from "./CheckConfirmationDeliveredTable.vue?vue&type=template&id=2b47e16f&"
import script from "./CheckConfirmationDeliveredTable.vue?vue&type=script&lang=js&"
export * from "./CheckConfirmationDeliveredTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports